import script from "./ListarPlanosMatriculas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPlanosMatriculas.vue?vue&type=script&setup=true&lang=js"

import "./ListarPlanosMatriculas.vue?vue&type=style&index=0&id=887db66a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-887db66a"]])

export default __exports__